// scrollBehavior.js
export function initializeScrollBehavior() {
  const body = document.body;
  const scrollUp = "scroll-up";
  const scrollDown = "scroll-down";
  const navHeight = document.querySelector('.kelo-nav').clientHeight;
  console.log(navHeight);
  const mainElement = document.querySelector('#main');
  mainElement.style.marginTop = navHeight + 'px';
  let lastScroll = 0;

  window.addEventListener("scroll", () => {
    const el = document.querySelector('#main');
    let viewportOffset = el.getBoundingClientRect();
    // These are relative to the viewport
    const top = viewportOffset.top;

    const currentScroll = window.scrollY;
    if (currentScroll <= 0) {
      body.classList.remove(scrollUp);
      return;
    }

    if (currentScroll > lastScroll && !body.classList.contains(scrollDown) && (top < 0)) {
      // Down
      body.classList.remove(scrollUp);
      body.classList.add(scrollDown);
    } else if (currentScroll < lastScroll && body.classList.contains(scrollDown)) {
      // Up
      body.classList.remove(scrollDown);
      body.classList.add(scrollUp);
    }
    lastScroll = currentScroll;
  });
}

